import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  departments: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const departmentsSlice = createSlice({
  name: 'departments',
  initialState: initialState,
  reducers: {
    setDepartment: (state, { payload }) => {
      state.departments = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setDepartments: (state, { payload }) => {
      console.log("payload", payload)
      state.departments = payload?.data || [];
      state.total = payload?.data?.total || 0;
      state.is_more = payload?.data?.is_more || false;
      state.last_page = payload?.data?.last_page || 1;
      state.current_page = payload?.data?.current_page || 1;
      state.per_page = payload?.data?.per_page || PAGELENGTH;
    },
    setMoreDepartments: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeDepartment: (state, { payload }) => {
      state.error = payload
    },
    clearAllDepartment: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addDepartment = (data, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.addDepartment(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setDepartment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
    else{
      
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader &&  dispatch(setLoader(false))
}

export const updateDepartment = (data, itemId, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader &&  dispatch(setLoader(true))
  try {

    const json = await Api.updateDepartment(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setDepartment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader && dispatch(setLoader(false))
}

export const removeDepartment = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeDepartment(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setDepartment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const fetchDepartmentsList = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchDepartmentsList(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setDepartments(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setDepartments(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
    else{
      !disableLoader && dispatch(setLoader(false))

    }
  } catch (error) {
    console.log("error", error)
  }
}
export const fetchDepartments = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchDepartments(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setDepartments(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setDepartments(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
    else{
      !disableLoader && dispatch(setLoader(false))

    }
  } catch (error) {
    console.log("error", error)
  }
}

export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "locations/departments")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleDepartments = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleDepartments(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setDepartment, setDepartments, clearAllDepartment, setLoader, setError, setMoreDepartments } = departmentsSlice.actions


export default departmentsSlice.reducer
export const departmentsSelector = state => state.departments